import TabletCard from "../../components/tablets/TabletCard";
import { TABLETTES } from "../../data/tablettes";

const Tablettes = () => {
  const fourrees = TABLETTES.filter(t => t.type === "fourree");
  const garnies = TABLETTES.filter(t => t.type === "garnie");

  return (
    <div className="section-padding">
      <h1 className="text-4xl font-bold mb-12">Nos Tablettes</h1>

      <section className="mb-20">
        <h2 className="text-3xl font-semibold mb-6">Tablettes Fourrées</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {fourrees.map(t => (
            <TabletCard key={t.id} tablet={t} />
          ))}
        </div>
      </section>

      <section>
        <h2 className="text-3xl font-semibold mb-6">Tablettes Garnies</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {garnies.map(t => (
            <TabletCard key={t.id} tablet={t} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default Tablettes;
